import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

export type ReportTargetLabel = 'Post' | 'Blog' | 'Event' | 'Comment';

@Component({
  selector: 'app-report-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './report-modal.html',
  // Everything here is `position: fixed`, so the host must not generate a box
  // — mirrors ConfirmationPopup, which lives in the same grid contexts.
  styles: [':host { display: contents; }'],
})
export class ReportModal {

  @Input() isOpen = false;
  @Input() targetLabel: ReportTargetLabel = 'Post';
  @Input() isSubmitting = false;
  /** Set by the parent after a failed submit; cleared automatically on reopen/close. */
  @Input() errorMessage = '';

  @Output() submitted = new EventEmitter<string>();
  @Output() cancelled = new EventEmitter<void>();

  description = '';

  readonly maxLength = 1000;

  onBackdropClick(): void {
    if (this.isSubmitting) return;
    this.cancelled.emit();
  }

  onCancel(): void {
    if (this.isSubmitting) return;
    this.cancelled.emit();
  }

  onSubmit(): void {
    const trimmed = this.description.trim();
    if (!trimmed || this.isSubmitting) return;
    this.submitted.emit(trimmed);
  }

  /** Called by the parent once the popup is fully closed, so the textarea is blank next time. */
  reset(): void {
    this.description = '';
  }
}
